import { useUrlState } from "./useUrlState";

/**
 * Pagination helper backed by a single query parameter.
 * - Removes the param when the value equals the initial (default = 1) for cleaner URLs.
 */
interface UseUrlPaginationOptions {
  param?: string; // query param name (default: page)
  initial?: number; // default page number (default: 1)
}

export const useUrlPagination = ({
  param = "page",
  initial = 1,
}: UseUrlPaginationOptions = {}) =>
  useUrlState<number>({
    param,
    initial,
    // Encode: drop param if it's the initial page to keep URL concise
    encode: (v) => (v === initial ? null : String(v)),
    // Decode: parse int; fall back to initial on invalid input
    decode: (raw) => {
      const n = raw ? parseInt(raw, 10) : initial;
      return !Number.isNaN(n) && n > 0 ? n : initial;
    },
  });
